/**
 * Browser Notifications Utility
 * Handles browser notification permissions and display
 */

class BrowserNotifications {
    constructor() {
      this.permission = null;
      this.checkPermission();
    }
  
    /**
     * Check notification permission
     */
    checkPermission() {
      if ('Notification' in window) {
        this.permission = Notification.permission;
      } else {
        this.permission = 'unsupported';
      }
      return this.permission;
    }
  
    /**
     * Request notification permission
     */
    async requestPermission() {
      if (!('Notification' in window)) {
        console.warn('⚠️ Browser does not support notifications');
        return false;
      }
  
      if (this.permission === 'granted') {
        return true;
      }
  
      if (this.permission === 'denied') {
        console.warn('⚠️ Notification permission denied');
        return false;
      }
  
      try {
        const permission = await Notification.requestPermission();
        this.permission = permission;
        return permission === 'granted';
      } catch (error) {
        console.error('❌ Error requesting notification permission:', error);
        return false;
      }
    }
  
    /**
     * Show notification for new message
     */
    showNotification(title, options = {}) {
      if (!('Notification' in window)) {
        return null;
      }
  
      if (this.permission !== 'granted') {
        // Try requesting permission
        this.requestPermission().then(granted => {
          if (granted) {
            this._createNotification(title, options);
          }
        });
        return null;
      }
  
      return this._createNotification(title, options);
    }
  
    /**
     * Create notification
     */
    _createNotification(title, options) {
      const defaultOptions = {
        body: options.body || '',
        // Use same icon as HTML tab (public/favicon.ico)
        icon: options.icon || `${process.env.PUBLIC_URL || ''}/favicon.ico`,
        badge: options.badge || `${process.env.PUBLIC_URL || ''}/favicon.ico`,
        tag: options.tag || 'chat-message',
        requireInteraction: false,
        silent: false,
      };
  
      try {
        const notification = new Notification(title, { ...defaultOptions, ...options });
        
        // Auto-close after 5 seconds
        setTimeout(() => {
          notification.close();
        }, 5000);
  
        // Handle click
        notification.onclick = (event) => {
          event.preventDefault();
          window.focus();
          if (options.onClick) {
            options.onClick();
          }
          notification.close();
        };
  
        return notification;
      } catch (error) {
        console.error('❌ Error creating notification:', error);
        return null;
      }
    }
  
    /**
     * Check if page is visible
     */
    isPageVisible() {
      if (typeof document === 'undefined') return true;
      return !document.hidden;
    }
  
    /**
     * Setup visibility change listener
     */
    onVisibilityChange(callback) {
      if (typeof document === 'undefined') return;
      
      document.addEventListener('visibilitychange', () => {
        callback(!document.hidden);
      });
    }
  }
  
  // Export singleton instance
  const browserNotifications = new BrowserNotifications();
  export default browserNotifications;
  
  
  
  